import classNames from 'classnames';
import { ReactNode, RefObject, useCallback, useMemo } from 'react';
import * as React from 'react';

import { makeGridPopupContainer } from '../../../containers/GridPopup/GridPopup';
import { Bem } from '../../../service/Bem/Bem';
import { TestBem } from '../../../service/TestBem';
import { ActionsMenu, ActionsMenuItem, ActionsMenuProps } from '../../ActionsMenu/ActionsMenu';
import { Shape2Icon } from '../../Shape2/Shape2';

import './PhrasesSelectorSelectedBlock.css';

export interface PhrasesSelectorSelectedBlockActions {
    info: ActionsMenuItem;
    handler: () => void;
}

export interface PhrasesSelectorSelectedBlockProps {
    className: string;
    title: string;
    actions: Record<string, PhrasesSelectorSelectedBlockActions>;
    children: ReactNode;
}

const BLOCK = 'phrases-selector-selected-block';

const ActionMenuPopupContainer = makeGridPopupContainer<ActionsMenuProps>(ActionsMenu);

export const PhrasesSelectorSelectedBlock = React.forwardRef(
    ({ className, title, actions, children }: PhrasesSelectorSelectedBlockProps, ref: RefObject<HTMLDivElement>) => {
        const onItemSelect = useCallback((event: React.MouseEvent<HTMLElement>, action: string) => {
            actions[action].handler();
        }, []);
        const actionItems = useMemo(
            () => [
                {
                    items: Object.keys(actions).map(key => actions[key].info)
                }
            ],
            [actions]
        );

        return (
            <div ref={ref} className={classNames(Bem.cls(BLOCK), className)}>
                <div className={Bem.cls(BLOCK, 'header')}>
                    <span className={Bem.cls(BLOCK, 'title')}>{title}</span>
                    <ActionMenuPopupContainer
                        isLink={true}
                        actions={actionItems}
                        icon={Shape2Icon.settings}
                        popupPosition="right-alt"
                        className={classNames(Bem.cls(BLOCK, 'actions'), TestBem.cls(BLOCK, 'actions'))}
                        onItemSelect={onItemSelect}
                    />
                </div>
                <div className={Bem.cls(BLOCK, 'list-wrapper')}>{children}</div>
            </div>
        );
    }
);
